import {css} from 'styled-components';

import {getAsset} from 'web-app/shared/white-labeling-constants';
import {getWhitelabel} from 'web-app/shared/white-labeling-helpers';

const getStyling = () => {
    // TODO: espira does not work on print
    return css`
        ${getExtraStyling()}
        ${getBackgroundImage()}
    `;
};

const getExtraStyling = () => {
    const whitelabel = getWhitelabel();

    switch (whitelabel) {
        case 'brighthorizons': {
            return css`
                width: 150px;
            `;
        }
        case 'monkeypuzzle': {
            return css`
                width: 150px;
            `;
        }
        case 'grandiruk': {
            return css`
                width: 64px;
            `;
        }
        case 'nuffieldhealth': {
            return css`
                width: 100x;
            `;
        }
        case 'kindred': {
            return css`
                width: 150px;
            `;
        }
        case 'kido': {
            return css`
                width: 150px;
            `;
        }
        case 'nfamilyclub': {
            return css``;
        }
        case 'bbmontessori':
            return css`
                width: 100px;
            `;
        case 'espira':
        case 'kinderzimmeruk':
        case 'cpctreehouse':
        case 'cpcorchards':
        case 'busybees':
        case 'bbodyssey':
        case 'famly':
        case null:
            return css``;

        default:
            return css``;
    }
};

const getBackgroundImage = () => {
    const background = getPrintHeaderLogo();
    return css`
        &:after {
            background-image: ${background};
        }
    `;
};

const getPrintHeaderLogo = () => {
    const whitelabel = getWhitelabel();
    if (whitelabel) {
        const logoImg = getAsset(whitelabel, 'logoPrint');
        if (logoImg) {
            return `url(${logoImg})`;
        }
    }

    switch (whitelabel) {
        case 'espira': {
            // the espira logo was never working here.
            // due to issues with it, it was removed altogether
            // see: https://github.com/famly/app/pull/27519
            // see: https://famlyapp.slack.com/archives/C06QNN69CCW/p1711115037520659
            return '';
        }
        case 'kido':
            return 'url(img/kido/kido-blue.png)';
        case 'brighthorizons':
            return 'url(img/bright-horizons/login-logo.svg)';
        case 'kindred':
            return 'url(img/kindred/logo-white-bg.svg)';
        case 'monkeypuzzle':
            return 'url(img/monkeypuzzle/logo.svg)';
        case 'grandiruk':
            return 'url(img/grandiruk/GrandirLogo-WhiteBG.svg)';
        case 'nuffieldhealth':
            return 'url(img/nuffieldhealth/NuffieldLogo-WhiteBG.svg)';
        case 'nfamilyclub':
            return 'url(img/nfamilyclub/logo-white-bg.svg)';
        case 'kinderzimmeruk':
            return 'url(img/kinderzimmeruk/KinderzimmerUKLogoMark.svg)';
        case 'cpctreehouse':
            return 'url(img/cpc-treehouse/CpcTreehouseLogoMark.svg)';
        case 'cpcorchards':
            return 'url(img/cpc-orchard/CpcOrchardLogoMark.svg)';
        case 'busybees':
            return 'url(img/busybees/BusyBeesLogo.svg)';
        case 'bbmontessori':
            return 'url(img/bbmontessori/logo-white-bg.svg)';
        case 'bbodyssey':
            return 'url(img/bbodyssey/logo-white-bg.svg)';
        case 'famly':
        case null:
            return 'url(img/famly-logos/Famly-Logo-WhiteBG.svg)';
        default:
            return 'url(img/famly-logos/Famly-Logo-WhiteBG.svg)';
    }
};

export default getStyling;
